import React, { useEffect, useState } from 'react'

import 'react-multi-carousel/lib/styles.css'
import toast from 'react-hot-toast'
import { useTranslation } from 'react-i18next'
import { Link, useNavigate, useSearchParams } from 'react-router-dom'

import { ClientsList } from './ClientsList'
import AppLayout from '../common/AppLayout'
import AppTitle from '../common/AppTitle'
// Pridané importy
import { useAuth } from '../common/Auth'
import { fetchClients } from '../common/helpers'
import { Package } from '../types/gopay'

function ClientsPage() {
    const {t} = useTranslation()
    const [searchParams,] = useSearchParams()
    const successInUrl = searchParams.get('showSuccess')
    const auth = useAuth()
    const navigate = useNavigate()
    const [canAdd, setCanAdd] = useState(false)

    useEffect(() => {
        if (auth.user?.selectedPackage === Package.FREE) {
            navigate('/app/dashboard')
            toast.error(t('free_no_clients_access'))
        }
    }, [auth.user, navigate])

    useEffect(() => {
        if (successInUrl) {
            toast.success(t('client_paired_social_success'))
        }
    }, [successInUrl])

    // Kontrola limitov
    useEffect(() => {
        fetchClients().then((clients) => {
            const currentCount = clients.length
            const userPackage = auth.user?.selectedPackage

            let limit = 0
            switch (userPackage) {
                case Package.FREE:
                    limit = 0 // Free nemá prístup ku klientom
                    break
                case Package.BASIC:
                    limit = 3
                    break
                case Package.MEDIUM:
                    limit = 7
                    break
                case Package.PREMIUM:
                    limit = 99999 // Neobmedzené
                    break
                default:
                    limit = 0
            }

            setCanAdd(currentCount < limit)
        }).catch(console.error)
    }, [auth.user])

    return (
        <AppLayout>
            <AppTitle append={
                canAdd ? (
                    <Link to={'/app/clients/add'}>
                        <button className="amani-primary">{t('add_new_client')}</button>
                    </Link>
                ) : null
            }>
                {t('clients')}
            </AppTitle>

            <ClientsList/>
        </AppLayout>
    )
}

export default ClientsPage